import React, {useCallback, useEffect, useState} from 'react';
import {Button, Form, message, Modal, Segmented, Select} from 'antd';
import {useRequest} from 'ahooks';
import {connect} from 'react-redux';
import {isUndefined} from 'lodash';
import CheckItem from '@/page-components/verify/Query/check_item';
import VerifyQueryResult from '@/page-components/verify/QueryResult';
import {apiVerifyMyself, apiVerifyOther, apiVerifyOtherByIdentity,} from '@/services/verify';
import {VerifyData, VerifyOtherpeopleData} from '@/types/verify';
import {TUserInfoTypes} from '@/types/redux_type';
import {casLogin, createCertIdArray} from '@/utils/index';
import QueryInput from "@/page-components/verify/Query/QueryInput";
import styles from './styles.module.less';

export enum QueryMethod {
  forMe = 1,
  forOther,
}

type TSubmitQueryData = {
  page: number;
  pagesize: number;
  method: QueryMethod;
  status?: '1' | '2';
  realName: string;
  certNo: string;
};

type TVerifyQuery = {
  userInfo: TUserInfoTypes;
  method?: QueryMethod;
};

const VerifyQuery: React.FC<TVerifyQuery> = ({userInfo, method}) => {
  const [form] = Form.useForm();
  const [haveQuery, setHaveQuery] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<VerifyData[]>([]);
  const [otherPeopleData, setOtherPeopleData] = useState<VerifyOtherpeopleData>(
    {certnoUrl: '', issuanceDate: 0},
  );
  const [queryData, setQueryData] = useState<TSubmitQueryData>({
    method: QueryMethod.forMe,
    page: 0,
    pagesize: 20,
    status: '1',
    realName: '',
    certNo: '',
  });
  const {loading: verifyOtherLoading, run: doVerifyOther} = useRequest(
    async (params) => {
      const queryDataTotal = {...queryData, ...params};
      if (form.getFieldValue('type') === '1') {
        queryDataTotal.certNo = queryDataTotal.number;
        return apiVerifyOther({...queryDataTotal});
      }
      queryDataTotal.certNo = queryDataTotal.identity;
      return apiVerifyOtherByIdentity({...queryDataTotal});
    },
    {
      manual: true,
      loadingDelay: 1,
      onError: () => {
        message.warning('查询失败，请稍后重试');
      },
      onSuccess: (res, params) => {
        if (res.code === 200 && res.success) {
          if (Object.keys(res.data).length === 0) {
            Modal.warning({
              title: '未查询到证书',
              content: <p>请检查输入的姓名和证书编号是否正确</p>,
              okText: '我知道了',
            });
          } else {
            setHaveQuery(true);
            setOtherPeopleData(res.data);
          }
        } else {
          message.warning('查询失败，请稍后重试');
        }
      },
    },
  );
  const {loading, run, runAsync} = useRequest(
    (params) => {
      const queryDataTotal = {...queryData, ...params};
      return apiVerifyMyself({...queryDataTotal});
    },
    {
      loadingDelay: 1,
      manual: true,
      onError: () => {
        message.warning('查询失败，请稍后重试');
      },
      onSuccess: (res, params) => {
        if (res.code === 200 && res.success) {
          if (res.data.total > 0) {
            setTotal(res.data.total);
            setData(res.data.list);
            setQueryData((prevState) => ({...prevState, ...params[0]}));
            setHaveQuery(true);
          } else if (!haveQuery) {
            Modal.warning({
              title: '未查询到考试记录',
              content: (
                <p>
                  您还没有参加认证考试哦~<a href="/">了解帆软认证</a>
                </p>
              ),
              okText: '我知道了',
            });
          } else {
            setTotal(res.data.total);
            setData(res.data.list);
            setQueryData((prevState) => ({...prevState, ...params[0]}));
            setHaveQuery(true);
          }
        } else {
          message.warning('查询失败，请稍后重试');
        }
      },
    },
  );
  const queryForMe = useCallback(async () => {
    if (!isUndefined(userInfo)) {
      await run({startTime: null, endTime: null});
    } else {
      casLogin();
    }
    //if (!userInfo.uid) {
    //  message.warning('请先登录后查询', 1, () => {
    //    casLogin();
    //  });
    //} else {
    //  await run({ startTime: null, endTime: null });
    //}
  }, [userInfo, run]);
  useEffect(() => {
    if (!isUndefined(method)) {
      setQueryData((prev) => ({...prev, method}));
      if (method === QueryMethod.forMe) {
        setHaveQuery(true);
        queryForMe();
      }
    }
  }, [method, queryForMe]);
  return (
    <div className={styles.verify_page_body}>
      <div className={styles.tips_row}>
        <img
          alt=""
          src="/img/icon-notice.svg"
          className={styles.warning_icon}
        />
        帆软职业资格认证证书体系已经改版
        <a
          rel="noreferrer"
          className={styles.a_link}
          href="https://bbs.fanruan.com/thread-139180-1-1.html"
          target="_blank"
        >
          查看详情{'>'}
        </a>
      </div>
      {haveQuery ? (
        <VerifyQueryResult
          otherPeopleData={otherPeopleData}
          method={queryData.method}
          page={queryData.page}
          onQuery={async (params) => {
            try {
              if (queryData.method === QueryMethod.forMe) {
                await runAsync({...params});
                return {message: true};
              }
              await doVerifyOther({...params});
              return {message: true};
            } catch (e) {
              message.warning('查询失败，请稍后重试');
              return {message: true};
            }
          }}
          total={total}
          data={data}
          onBack={() => {
            setHaveQuery(false);
            setData([]);
          }}
        />
      ) : (
        <>
          <div className={styles.query_body}>
            <p className={styles.query_body_title}>查询方式</p>
            <CheckItem
              onChange={(value) => {
                setQueryData((prev) => ({...prev, method: value}));
              }}
              activeMethod={queryData.method}
              method={QueryMethod.forMe}
              title="查询本人证书"
              subtitle="用于查询自己的认证考试记录和证书情况"
            />
            <CheckItem
              onChange={(value) => {
                setQueryData((prev) => ({...prev, method: value}));
              }}
              activeMethod={queryData.method}
              method={QueryMethod.forOther}
              title="查询他人证书"
              subtitle="帮助用人单位鉴别证书是否真实有效"
            />
            {queryData.method === QueryMethod.forOther && (
              <Form
                form={form}
                layout="vertical"
                className={styles.query_body_input_item}
              >
                <Form.Item
                  initialValue="1"
                  className={styles.query_body_input_item}
                  name="type"
                  label={
                    <p className={styles.query_body_input_item_title}>
                      查询方式
                    </p>
                  }
                >
                  <Segmented
                    onChange={(value) => {
                      form.setFieldsValue({
                        type: value,
                        realName: undefined,
                        number: undefined,
                        identity: undefined,
                        certId: undefined,
                      });
                    }}
                    block
                    options={[
                      {label: '通过证书编号查询', value: '1'},
                      {label: '通过身份证号查询', value: '2'},
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  className={styles.query_body_input_item}
                  name="realName"
                  label={
                    <p className={styles.query_body_input_item_title}>
                      真实姓名
                    </p>
                  }
                  rules={[{required: true, message: '请输入其真实姓名'}]}
                >
                  <QueryInput placeholder="请输入查询用户真实姓名"/>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.type !== currentValues.type
                  }
                >
                  {({getFieldValue}) =>
                    getFieldValue('type') === '1' ? (
                      <Form.Item
                        name="number"
                        label={
                          <p className={styles.query_body_input_item_title}>
                            证书编号
                          </p>
                        }
                        rules={[{required: true, message: '请输入证书编号'}]}
                      >
                        <QueryInput placeholder="请输入证书编号（12位或15位）"/>
                      </Form.Item>
                    ) : (
                      <>
                        <Form.Item
                          name="identity"
                          label={
                            <p className={styles.query_body_input_item_title}>
                              身份证号
                            </p>
                          }
                          rules={[
                            {required: true, message: '请输入身份证号'},
                          ]}
                        >
                          <QueryInput placeholder="请输入查询用户实名认证时的身份证号码"/>
                        </Form.Item>
                        <Form.Item
                          name="certId"
                          label={
                            <p className={styles.query_body_input_item_title}>
                              认证类型
                            </p>
                          }
                          rules={[
                            {required: true, message: '请选择认证类型'},
                          ]}
                        >
                          <Select
                            placeholder="请选择要查询的认证类型"
                            options={createCertIdArray().map((item) => ({
                              key: item.certId,
                              label: item.name,
                              value: item.certId,
                            }))}
                          />
                        </Form.Item>
                      </>
                    )
                  }
                </Form.Item>
              </Form>
            )}
            <Button
              loading={loading || verifyOtherLoading}
              disabled={loading || verifyOtherLoading}
              onClick={async () => {
                const res = await form.validateFields();
                if (queryData.method === QueryMethod.forOther) {
                  await doVerifyOther(res);
                } else {
                  await queryForMe();
                }
              }}
              type="primary"
              className={styles.query_body_btn}
            >
              立即查询
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
export default connect((state: { userInfo: TUserInfoTypes }) => {
  return state;
})(VerifyQuery);
